import { IframeChatConfigResponseData } from "schema"
import z from "zod"

type IframeChatPhone = z.infer<typeof IframeChatConfigResponseData>["phone"]

export const iframeChatPhoneOptions: Array<IframeChatPhone & { id: string; label: string }> = [
  {
    id: "iphone-15-pro",
    label: "iPhone 17 Pro",
    image: "https://production-permut.s3.eu-west-3.amazonaws.com/widget/phones/iphone-15-pro.png",
    padding: "25px 59px 26px 58px",
    iframePadding: "0",
    borderRadius: "34px",
    aspectRatio: "370 / 608",
  },
  {
    id: "samsung-galaxy-s24",
    label: "Samsung Galaxy S24",
    image:
      "https://production-permut.s3.eu-west-3.amazonaws.com/widget/phones/samsung-galaxy-s24.png",
    padding: "46px 68px 46px 66px",
    iframePadding: "20px 0 0",
    borderRadius: "2px",
    aspectRatio: "370 / 608",
  },
  {
    id: "google-pixel-8",
    label: "Google Pixel 8",
    image: "https://production-permut.s3.eu-west-3.amazonaws.com/widget/phones/google-pixel-8.png",
    padding: "14px 59px 15px 55px",
    iframePadding: "20px 0 0 0",
    borderRadius: "15px",
    aspectRatio: "370 / 608",
  },
  {
    id: "no-phone",
    label: "No phone",
    image: "https://production-permut.s3.eu-west-3.amazonaws.com/widget/phones/transparent.png",
    padding: "0",
    iframePadding: "0",
    borderRadius: "10px",
    aspectRatio: "370 / 608",
  },
]

export const defaultIframeChatPhone = iframeChatPhoneOptions[0]!
